import C from "./atoms-v21008.js";
import { getCountryCallingCode as g } from "./atoms-v271.js";
import { getExampleNumber as d } from "./atoms-v273.js";
function b(t) {
  const i = String(g(t)), r = d(t, C);
  if (r) {
    const c = r.nationalNumber, a = r.formatNational(), e = a.replace(/\D/g, ""), l = Math.max(0, e.length - c.length);
    let u = 0, h = "";
    for (const f of a) {
      if (u < l && /\d/.test(f)) {
        u++;
        continue;
      }
      h += f;
    }
    const m = h.replace(/\d/g, "_"), o = `+${i} ${m}`.replace(/\s+$/, ""), s = (m.match(/_+/g) || []).reduce((f, x) => f + x.length, 0);
    return { mask: o, maxDigits: s };
  }
  const n = 10;
  return {
    mask: `+${i} ${"_".repeat(n)}`,
    maxDigits: n
  };
}
function D(t, i) {
  const r = b(t), n = [], c = i.slice(0, r.maxDigits);
  let a = 0;
  const l = Array.from(r.mask, (o, s) => o === "_" ? (n.push(s), a < c.length ? c[a++] : "_") : o).join(""), u = n[0] ?? l.length;
  return {
    caretToLocalIndex: (o) => {
      let s = 0;
      for (; s < n.length && o > n[s]; )
        s++;
      return s;
    },
    firstEditableCaret: u,
    localIndexToCaret: (o) => {
      if (!n.length)
        return l.length;
      const s = Math.max(0, Math.min(o, n.length));
      return s === n.length ? n[n.length - 1] + 1 : n[s];
    },
    masked: l,
    maxDigits: r.maxDigits
  };
}
const M = (t) => t.replace(/\D/g, ""), N = (t, i) => i < 0 || i >= t.length ? t : t.slice(0, i) + t.slice(i + 1), S = (t, i, r, n = 1 / 0) => {
  const c = Math.max(0, Math.min(i, r)), a = Math.max(0, Math.max(i, r));
  return c >= t.length || c === a ? t : (t.slice(0, c) + t.slice(Math.min(a, t.length))).slice(0, n);
}, _ = (t, i, r, n = 1 / 0) => i < 0 ? t : i >= t.length ? (t + r).slice(0, n) : t.slice(0, i) + r + t.slice(i + 1), $ = (t, i, r, n = 1 / 0) => {
  const c = t.slice(0, i), a = t.slice(i);
  return (c + r + a).slice(0, n);
};
function E(t, i) {
  const r = t.trim();
  if (!r.startsWith("+"))
    return null;
  const n = M(r);
  if (!n)
    return null;
  const c = {};
  for (const a of i) {
    const e = String(g(a));
    (c[e] || (c[e] = [])).push(a);
  }
  for (let a = 3; a >= 1; a--) {
    const e = n.slice(0, a);
    if (!e)
      continue;
    const l = c[e];
    if (!l || l.length === 0)
      continue;
    const u = l[0], h = n.slice(e.length);
    return { callingCode: e, country: u, localDigits: h };
  }
  return null;
}
export {
  D as computeMaskState,
  S as deleteCharRange,
  M as getDigitsFromString,
  $ as insertCharAt,
  E as matchCountryFromE164,
  b as prefixedMaskBuilder,
  N as removeCharAt,
  _ as replaceCharAt
};
